import { render, staticRenderFns } from "./AddAliasDialog.vue?vue&type=template&id=617b1b39"
import script from "./AddAliasDialog.vue?vue&type=script&lang=js"
export * from "./AddAliasDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports